/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import SecurityIcon from 'icons/SecurityIcon';

const messages = defineMessages({
  title: {id: 'navigation.change-password'},
});

const ChangePasswordItem = () => (
  <RouteLinkItem
    iconBefore={SecurityIcon}
    route="midas/change-password"
    title={messages.title}
  />
);

export default ChangePasswordItem;
